import api from './api-config';
import { ClinicalNotesDTO } from '../models/ClinicalNotes';

export const clinicalNotesService = {
  getAllClinicalNotes: async (params: {
    page?: number;
    size?: number;
    sort?: string[];
    'id.greaterThan'?: number;
    'id.lessThan'?: number;
    'id.equals'?: number;
    'noteType.equals'?: 'ANAMNESI_FAMILIARE' | 'ANAMNESI_PATOLOGICA' | 'ESAMI_ALTERATI' | 'PATOLOGIE_PREGRESSE' | 'INTERVENTI_CHIRURGICI' | 'ALLERGIE_INTOLLERANZE' | 'TERAPIE_IN_CORSO';
    'description.contains'?: string;
    'description.equals'?: string;
    'casesId.equals'?: number;
    distinct?: boolean;
  } = {}) => {
    const response = await api.get<ClinicalNotesDTO[]>('/clinical-notes', { 
      params: { 
        ...params,
        sort: params.sort?.join(',')
      } 
    });
    return response.data;
  },

  getClinicalNote: async (id: number) => {
    const response = await api.get<ClinicalNotesDTO>(`/clinical-notes/${id}`);
    return response.data;
  },

  createClinicalNote: async (clinicalNoteData: ClinicalNotesDTO) => {
    const response = await api.post<ClinicalNotesDTO>('/clinical-notes', clinicalNoteData);
    return response.data;
  },

  updateClinicalNote: async (id: number, clinicalNoteData: ClinicalNotesDTO) => {
    const response = await api.put<ClinicalNotesDTO>(`/clinical-notes/${id}`, clinicalNoteData);
    return response.data;
  },

  deleteClinicalNote: async (id: number) => {
    await api.delete(`/clinical-notes/${id}`);
  },

  partialUpdateClinicalNote: async (id: number, clinicalNoteData: Partial<ClinicalNotesDTO>) => {
    const response = await api.patch<ClinicalNotesDTO>(`/clinical-notes/${id}`, clinicalNoteData);
    return response.data;
  },

  countClinicalNotes: async (params: {
    'id.greaterThan'?: number;
    'id.lessThan'?: number;
    'id.equals'?: number;
    'noteType.equals'?: 'ANAMNESI_FAMILIARE' | 'ANAMNESI_PATOLOGICA' | 'ESAMI_ALTERATI' | 'PATOLOGIE_PREGRESSE' | 'INTERVENTI_CHIRURGICI' | 'ALLERGIE_INTOLLERANZE' | 'TERAPIE_IN_CORSO';
    'description.contains'?: string;
    'description.equals'?: string;
    'casesId.equals'?: number;
    distinct?: boolean;
  } = {}) => {
    const response = await api.get<number>('/clinical-notes/count', { params });
    return response.data;
  }
};